<template>
  <v-layout>
    <v-flex>
      <v-card-title class="">
        <div class="">
          <span class="headline red--text">Dasher Filtering </span>
        </div>
      </v-card-title>
      <v-layout row class="mx-2" v-if="allowedRespondentFilter()">
        <v-flex xs2>
          <v-switch
            v-model="filteringOnOff"
            :label="`${filteringOnOff?'ON':'Off'}`"
            color="success"
            value="success"
            hide-details
          ></v-switch>
        </v-flex>
        <v-flex v-if="filteringOnOff" xs4 @click="addGroup()">
          <v-btn> Add Group </v-btn>
        </v-flex>
      </v-layout>

      <v-layout row class="mx-2" v-else>
        You have no permission to use filtering.
        <router-link to="/subscription-package">
          <p>
            click here to upgrade your subscription to premium or corporate
          </p></router-link
        >
      </v-layout>
      <v-form
        ref="form"
        lazy-validation
        v-if="isLoadedIndex() && filteringOnOff"
      >
        <v-card-text
          v-for="(filter_group, index) in filteringData.add_filter_group"
          v-bind:key="index"
        >
          <v-btn class="fa-pull-right"> Group - {{ index }}</v-btn>
          <v-layout
            row
            v-for="(add_filtering, counter) in filter_group.add_filterings"
            v-bind:key="counter"
          >
            <v-flex xs3 class="mx-1">
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .filtering_parameter_id
                "
                :items="filteringParams"
                item-text="parameter_name"
                item-value="id"
                box
                label="Parameters"
                :rules="[(v) => !!v || 'This field is required!']"
                @change="filterOperator($event, index, counter)"
              >
              </v-select>
            </v-flex>
            <v-flex xs3 class="mx-1">
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .comparison_operator_id
                "
                :items="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .filter_operator
                "
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'This field is required!']"
                box
                @change="resetHasData()"
                label="Conditions"
              >
              </v-select>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 1
              "
            >
              <v-text-field
                v-model.lazy="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .age1
                "
                box
                :rules="[(v) => !!v || 'This field is required!']"
                @keypress="resetHasData()"
                @keydown="resetHasData()"
                label="Age"
              >
              </v-text-field>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                (filteringData.add_filter_group[index].add_filterings[counter]
                  .comparison_operator_id == 8 ||
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .comparison_operator_id == 9) &&
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 1
              "
            >
              <v-text-field
                v-model.lazy="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .age2
                "
                box
                :rules="[(v) => !!v || 'This field is required!']"
                label="Age2"
                @keypress="resetHasData()"
                @keydown="resetHasData()"
              >
              </v-text-field>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 3
              "
            >
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .division_id
                "
                :rules="[(v) => !!v || 'This field is required!']"
                :items="divisions"
                item-text="english_title"
                item-value="id"
                box
                multiple
                label="Division"
                @change="resetHasData()"
              >
              </v-select>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 4
              "
            >
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .district_id
                "
                :rules="[(v) => !!v || 'This field is required!']"
                :items="districts"
                item-text="english_title"
                item-value="id"
                box
                multiple
                label="District"
                @change="resetHasData()"
              >
              </v-select>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 2
              "
            >
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .gender_id
                "
                :items="genders"
                item-text="name"
                item-value="id"
                box
                multiple
                label="Gender"
                :rules="[(v) => !!v || 'This field is required!']"
                @change="resetHasData()"
              >
              </v-select>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 5
              "
            >
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .education_id
                "
                :items="educations"
                item-text="name"
                item-value="id"
                box
                multiple
                label="Educations"
                @change="resetHasData()"
                :rules="[(v) => !!v || 'This field is required!']"
              >
              </v-select>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 6
              "
            >
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .profession_id
                "
                :items="professions"
                item-text="name"
                item-value="id"
                box
                multiple
                label="Professions"
                :rules="[(v) => !!v || 'This field is required!']"
                @change="resetHasData()"
              >
              </v-select>
            </v-flex>
            <v-flex
              class=""
              xs3
              v-if="
                filteringData.add_filter_group[index].add_filterings[counter]
                  .filtering_parameter_id == 7
              "
            >
              <v-select
                v-model="
                  filteringData.add_filter_group[index].add_filterings[counter]
                    .income_id
                "
                :items="income"
                item-text="name"
                item-value="id"
                box
                multiple
                label="Income"
                :rules="[(v) => !!v || 'This field is required!']"
                @change="resetHasData()"
              >
              </v-select>
            </v-flex>

            <v-flex xs3>
              <v-icon
                v-if="counter != 0"
                @click="deleteFiltering(index, counter)"
              >
                clear
              </v-icon>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6>
              <span class="material-icons" @click="addMore(index)">
                add_circle_outline
              </span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-icon @click="deleteFilterGroup(index)"> clear </v-icon>
            </v-flex>
          </v-layout>
          <br />
        </v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-btn
              :disabled="haveData"
              color="green"
              elevation="2"
              @click="check"
              >Check Available Dasher</v-btn
            >
          </v-flex>

          <v-flex xs12 ml-2>
            <h3>Number of available dasher: {{ checkDasher }}</h3>
          </v-flex>

          <br />

          <!-- <v-btn color="blue" v-if="haveData">Available Dasher {{ checkDasher }}</v-btn> -->
        </v-layout>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <button class="button" flat @click="back">Back</button>
        <v-btn
          class="button"
          v-if="filteringOnOff"
          flat
          @click="submit"
          >Save & next</v-btn
        >
        <v-btn class="button" v-else flat @click="skip">Save & next</v-btn>
      </v-card-actions>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
// import router from "../../router";
import utilities from "@/api/utilities.js";
import api from "@/api/datadash";
export default {
  props: {
    dataset: Object,
  },
  data: () => ({
    apiUrl: "project-filtering-param-data",
    responseData: {},
    filteringParams: [],
    districts: [],
    divisions: [],
    educations: [],
    genders: [],
    income: [],
    operators: [],
    professions: [],
    project_data: {},
    dialog: false,
    snackbar: false,
    filteringOnOff: false,
    y: "top",
    x: "right",
    timeout: 4000,
    loader: null,
    numberOtLogics: 1,
    maxAllowedRespondentFilterLimit: 1,
    loading4: false,
    editedIndex: -1,
    total_filter_price: 0,
    filter_array: [],
    filteringData: {
      add_filter_group: [
        {
          add_filterings: [
            {
              filtering_parameter_id: "",
              comparison_operator_id: "",
              division_id: "",
              district_id: "",
              gender_id: "",
              education_id: "",
              profession_id: "",
              income_id: "",
              age1: "",
              age2: "",
              filter_operator: [],
            },
          ],
        },
      ],
      filter_skip: false,
      available_dasher: null,
      project_id: null,
    },
    defaultItem: {
      filtering_parameter_id: "",
      comparison_operator_id: "",
      value: "",
      filter_operator: [],
      filter_skip: false,
      available_dasher: null,
      project_id: null,
    },
    notChecked: true,
    haveData: false,
  }),

  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
      // console.log(this.loader);
    },
  },

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
      "availableDasher",
    ]),
    checkDasher() {
      if (this.availableDasher) {
        return this.availableDasher;
      }
      return 0;
    },
  },

  created() {
    this.loadData();
  },

  methods: {
    initialize() {
      this.filteringParams = this.responseData.filteringParams;
      this.divisions = this.responseData.divisions;
      this.districts = this.responseData.districts;
      this.educations = this.responseData.educations;
      this.genders = this.responseData.genders;
      this.income = this.responseData.income;
      this.operators = this.responseData.operators;
      this.professions = this.responseData.professions;
      this.project_data = this.responseData.project_data;
      // console.log(this.dataset);
      // var project_id = JSON.parse(localStorage.getItem("project_id"));
      // this.filteringData.project_id = project_id;
      // this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    async loadData() {
      this.filteringData.project_id = this.$route.params.id;
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          let response = await api.fetchAllData(
            token,
            "project-filtering-param-data",
            this.$route.params.id
          );
          this.responseData = response.data.data;
          this.initialize();
        }
      } catch (error) {
        // console.log(error);
      }
    },

    addMore(index) {
      if (this.maxAllowedRespondentFilterLimit > this.numberOtLogics) {
        this.numberOtLogics = this.numberOtLogics + 1;
        // console.log(this.numberOtLogics);
        this.haveData = false;
        this.filteringData.add_filter_group[index].add_filterings.push({
          filtering_parameter_id: "",
          comparison_operator_id: "",
          division_id: "",
          district_id: "",
          gender_id: "",
          education_id: "",
          profession_id: "",
          income_id: "",
          age1: "",
          age2: "",
          filter_operator: [],
        });
      } else {
        alert(
          "You can add maximum " +
            this.maxAllowedRespondentFilterLimit +
            " logics"
        );
      }
    },
    resetHasData() {
      this.haveData = false;
    },

    addGroup() {
      if (this.maxAllowedRespondentFilterLimit > this.numberOtLogics) {
        this.numberOtLogics = this.numberOtLogics + 1;
        this.haveData = false;
        // console.log(this.filteringData);
        this.filteringData.add_filter_group.push({
          add_filterings: [
            {
              filtering_parameter_id: "",
              comparison_operator_id: "",
              division_id: "",
              district_id: "",
              gender_id: "",
              education_id: "",
              profession_id: "",
              income_id: "",
              age1: "",
              age2: "",
              filter_operator: [],
            },
          ],
        });
      } else {
        alert(
          "You can add maximum " +
            this.maxAllowedRespondentFilterLimit +
            " logics"
        );
      }

      // console.log(this.filteringData.add_filter_group);
    },

    deleteFiltering(index, counter) {
      this.filteringData.add_filter_group[index].add_filterings.splice(
        counter,
        1
      );
      this.haveData = false;
    },
    deleteFilterGroup(index) {
      this.haveData = false;
      this.filteringData.add_filter_group.splice(index, 1);
    },
    isLoadedIndex() {
      if (this.project_data) {
        return true;
      } else {
        return false;
      }
    },
    filterOperator(event, index, counter) {
      var filterValue = [];
      if (event == 1) {
        for (let i = 0; i < this.operators.length; i++) {
          if (this.operators[i].id != 6 && this.operators[i].id != 7) {
            filterValue.push(this.operators[i]);
          }
        }
      } else {
        for (let i = 0; i < this.operators.length; i++) {
          if (this.operators[i].id == 6 || this.operators[i].id == 7) {
            filterValue.push(this.operators[i]);
          }
        }
      }

      this.filteringData.add_filter_group[index].add_filterings[
        counter
      ].filter_operator = filterValue;
    },

    close() {
      setTimeout(() => {
        this.filteringData = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    back() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-dasher-category",
        project_id,
        "/assign-teams-to-Project",
      ]);
    },
    skip() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.filteringData.project_id = project_id;
      this.filteringData.filter_skip = true;
      this.$store.dispatch("storeOrUpdateFilterDasher", [
        "project-filtering-param-store",
        this.filteringData,
      ]);
    },
    allowedRespondentFilter() {
      this.allowedRespondentFilterLimit();
      return utilities.allowedRespondentFilter(
        this.subscriptionData.subscriptionFeatures
      );
    },
    allowedRespondentFilterLimit() {
      this.maxAllowedRespondentFilterLimit =
        utilities.allowedRespondentFilterLimit(
          this.subscriptionData.subscriptionFeatures
        );
    },
    check() {
      // console.log(this.filteringData);
      if (this.$refs.form.validate() == true) {
        this.haveData = false;
        this.$store.dispatch("checkDasher", [
          "project-dasher",
          this.filteringData,
        ]);
        this.haveData = true;
      }
    },

    needAssistant() {
      this.dialog = true;
      // this.snackbar = true;
      // this.close();
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },

    submit() {
      // alert("ok");
      // console.log(this.filteringData);
      if (this.$refs.form.validate() == true) {
        this.filteringData.available_dasher = this.availableDasher;
        this.filteringData.filter_skip = false;
        this.$store.dispatch("storeOrUpdateFilterDasher", [
          this.haveData
            ? "project-filtering-param-store"
            : "store-project-setting",
          this.filteringData,
        ]);
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.no-upercase {
  text-transform: unset !important;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
